import { ValueInteraction } from "./ValueInteraction";
import { TileRectangle } from "lib/runescape/coordinates/TileRectangle";
import { observe } from "lib/reactive";
export default class GameMapDragAction extends ValueInteraction {
    constructor(config) {
        super(config);
        this.config = config;
        this.dragstart = null;
        this.area = observe({ area: null, committed: false });
    }
    onAdd(map) {
        super.onAdd(map);
        map.dragging.disable();
        return this;
    }
    onRemove(map) {
        super.onRemove(map);
        map.dragging.enable();
        return this;
    }
    start(tile) {
        this.dragstart = tile;
        return this;
    }
    reset() {
        this.dragstart = null;
        this.area.set({ area: null, committed: false });
    }
    eventMouseDown(event) {
        event.onPre(() => {
            if (!this.dragstart) {
                event.stopAllPropagation();
                this.dragstart = event.tile();
                this.preview(TileRectangle.fromTile(event.tile()));
            }
        });
    }
    eventMouseUp(event) {
        event.onPre(() => {
            if (this.dragstart) {
                event.stopAllPropagation();
                this.commit(TileRectangle.from(this.dragstart, event.tile()));
            }
        });
    }
    eventClick(event) {
        // Capture and consume the click event, so it does not get sent to the default interaction
        event.onPre(() => {
            event.stopAllPropagation();
            if (this.dragstart)
                this.commit(TileRectangle.from(this.dragstart, event.tile()));
            else
                this.commit(TileRectangle.fromTile(event.tile()));
        });
    }
    eventHover(event) {
        event.onPre(() => {
            if (this.dragstart) {
                event.stopAllPropagation();
                this.preview(TileRectangle.from(this.dragstart, event.tile()));
            }
        });
    }
}
